"use client";

import { c as _c } from "react/compiler-runtime";
import { ShareButton } from "@/components/molecules/share/ShareButton";
import { ShareOptions } from "./ShareOptions";
type ShareDrawerProps = {
  title: string;
  aura?: boolean;
  children?: React.ReactNode;
  className?: string;
  fill?: string;
  realEstateId: string;
};
export function ShareDrawer(t0) {
  const $ = _c(9);
  const {
    title,
    aura,
    children,
    className,
    realEstateId
  } = t0;
  let t1;
  if ($[0] !== realEstateId || $[1] !== title) {
    t1 = <ShareOptions slug={realEstateId} title={title} />;
    $[0] = realEstateId;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== aura || $[4] !== children || $[5] !== className || $[6] !== t1 || $[7] !== title) {
    t2 = <ShareButton title={title} aura={aura} className={className} options={t1} data-sentry-element="ShareButton" data-sentry-component="ShareDrawer" data-sentry-source-file="share-drawer.tsx">{children}</ShareButton>;
    $[3] = aura;
    $[4] = children;
    $[5] = className;
    $[6] = t1;
    $[7] = title;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}